<div class="main-container">
  <form [formGroup]="dispatchForm" novalidate>
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Dispatched Devices</span>
      </div>

      @if (dispatchDeviceCreate) {
        <div class="button-group">
          <button class="primary-button" (click)="AddNew()">
            Manual & Bulk Upload<mat-icon class="btn-icon"
              >open_in_new</mat-icon
            >
          </button>
          <!-- <button class="primary-button" (click)="AddNewExcel()">
            Bulk Upload<mat-icon class="btn-icon">open_in_new</mat-icon>
          </button> -->
        </div>
      }
    </div>

    @if (dispatchDeviceView) {
      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">Dispatched Batch List</h6>
          <div class="component-actions">
            <app-common-component-dropdown-search
              [items]="filteredListOfCustomers"
              [initialValue]="customerId"
              [placeHolder]="'Select Customer'"
              (itemSelected)="onCustomerSelected($event)"
            ></app-common-component-dropdown-search>
            <app-common-search
              (searchSubmit)="onSearchInputChange($event)"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Batch Id</th>
                <th>UIN Start</th>
                <th>UIN End</th>
                <th>Customer Name</th>
                <th>Total Count</th>
                <th>Dispatch Date</th>
                @if (dispatchDeviceView || dispatchDeviceDelete) {
                  <th>Action</th>
                }
              </tr>
            </thead>
            @if (dispatchDeviceList.length > 0) {
              <tbody>
                @for (item of dispatchDeviceList; track item) {
                  <tr>
                    <td>{{ item.dispatchBatchId }}</td>
                    <td>{{ item.startUin }}</td>
                    <td>{{ item.endUin }}</td>
                    <td>{{ item.customerName }}</td>
                    <td>{{ item.totalCount }}</td>
                    <td>{{ item.dispatchDate | date: 'dd/MM/yyyy' }}</td>
                    <td>
                      <div class="action-buttons">
                        @if (dispatchDeviceUpdate) {
                          <button
                            (click)="prepopulation(item.dispatchBatchId)"
                            class="primary-button view-button"
                          >
                            <mat-icon class="btn-icon">visibility</mat-icon>
                          </button>
                        }
                        @if (dispatchDeviceDelete) {
                          <button
                            class="primary-button delete-button"
                            (click)="delete(item.dispatchBatchId)"
                          >
                            <mat-icon class="btn-icon">delete</mat-icon>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            }
            @if (dispatchDeviceList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="7">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <div class="component-separator"></div>
        <div class="component-footer">
          @if (dispatchDeviceList.length > 0) {
            <app-common-component-pagination
              [totalItems]="totalItems"
              [pageSize]="pageSize"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }
  </form>
</div>
